
import React, { useState } from 'react'
import Cover from './Cover/Cover'
import Savethedate from '../../FinalOutput/Components/SaveTheDate/Savethedate'
import Countdown from '../../FinalOutput/Components/Countdown/Countdown'
import Couple from './Couple/Couple'
import Events from '../../FinalOutput/Components/Events/Events'
import Sliderpre from './Slider/Sliderpre'
import Rsvpfooter from '../../FinalOutput/Components/RSVP&Footer/Rsvpfooter'
import Envelope from '../../FinalOutput/Components/Envelope/Envelope'
import PreviewMark from '../../../helpers/PreviewMark'
import { useSelector } from 'react-redux'
import Trialbadge from '../../../helpers/Trialbadge'
import Watermark from '../../../helpers/Watermark'
import PhotoControls from '../../../helpers/PhotoControls'
import MusicButton from '../../../helpers/MusicButton'

const Theme2 = ({details,events,demoExpired,isPreview,photoControls,playMusic,toggleMusic,isMusicPlaying,iconAnimate}) => {
    const {user} = useSelector(state => state.auth); 
  const [envelopeScreen, SetEnvelopeScreen] = useState(true)
  const [photoMode, setPhotoMode] = useState();
  
     
  return (
   <>
    {isPreview && <PreviewMark /> }

      {!isPreview && user?.demoVersion && !demoExpired && (
  <Trialbadge demoExpiryTime={user.demoExpiryTime} />
)}

{!isPreview && user?.demoVersion && !demoExpired && (
  <Watermark />
)}

{photoControls && !envelopeScreen && (
        <PhotoControls
          photoMode={photoMode}
          setPhotoMode={setPhotoMode}
        />
      )}

    {envelopeScreen ? <Envelope  SetEnvelopeScreen={SetEnvelopeScreen}  details={details} demoExpired={demoExpired} onOpen={playMusic} iconAnimate={iconAnimate} />: <> 
      
       <MusicButton
  enabled={details.music?.enabled}
  isMusicPlaying={isMusicPlaying}
  toggleMusic={toggleMusic}
  theme={details?.theme}
/>
      <Cover details={details} photoMode={photoMode} />
     <Savethedate details={details} />
     <Countdown  details={details} />
     <Couple  details={details} photoMode={photoMode} />
      <Events  events={events} theme={details?.theme} />
      <Sliderpre  details={details}  photoMode={photoMode} />
      <Rsvpfooter  details={details} />
    </>}
   
   </>
  )
}

export default Theme2